import React, {useState} from 'react';

import {MinimalFolder} from 'constants/FolderConstants';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import FormInput from 'ui-library/bs/FormInput';
import Label from 'ui-library/bs/Label';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import useStateIfMounted from 'ui-library/hooks/useStateIfMounted';
import {BasicEvent, GenericEvent} from 'util/Types';

export interface CreateFolderFormProps {
  createFolder(folderName: string): JQueryPromise<MinimalFolder>;
}

export default function CreateFolderForm(props: CreateFolderFormProps): JSX.Element {
  const [folderName, setFolderName] = useState<string>('');
  const [isCreating, setIsCreating] = useStateIfMounted<boolean>(false);

  const submitHandler = (e: BasicEvent): void => {
    e.preventDefault();
    setIsCreating(true);
    props.createFolder(folderName).always((_) => {
      setIsCreating(false);
    });
  };

  return (
    <div className="form-horizontal">
      <FormGroup className="u-no-spacing-bottom">
        <Label className="require col-sm-2 control-label">Name</Label>
        <Col sm={8}>
          <FormInput
            dataTestAttrs={{component: 'CreateFolderForm', element: 'input', key: 'folderName'}}
            focusOnMount={true}
            type="text"
            value={folderName}
            onChange={(e: GenericEvent) => {
              setFolderName(e.target.value);
            }}
          />
        </Col>
        <Col sm={2}>
          <Button
            buttonStyle={ButtonStyle.PRIMARY}
            dataTestAttrs={{component: 'CreateFolderForm', element: 'button', key: 'create'}}
            size={ButtonSize.SMALL}
            disabled={folderName.trim() === '' || isCreating}
            onClick={submitHandler}
            text="Create"
          />
        </Col>
      </FormGroup>
    </div>
  );
}
